var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpathy = function SvgEmpathy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M13.8 35.8c0-10.7 8.6-19.3 19.2-19.3h22c10.6 0 19.3 8.6 19.3 19.3v3c0 10.7-8.7 19.3-19.3 19.3h-4.3a2.8 2.8 0 0 0-1.7.6L34 70.4v-9.6a2.8 2.8 0 0 0-2.5-2.7c-10-.8-17.8-9-17.8-19.2v-3.1ZM33 11C19.3 11 8.2 22 8.2 35.8v3a25 25 0 0 0 20.4 24.5v12.9a2.8 2.8 0 0 0 4.4 2.1l18.6-14.6H55c13.7 0 24.8-11 24.8-24.7v-3.1A24.8 24.8 0 0 0 55 11H33Zm11 21.6s-7.4-13.4-14.7-5.2C22.6 35 36.6 46.8 42 50.8a3.3 3.3 0 0 0 4 0c5.4-3.9 19.7-15.3 12.6-23.4-7.4-8.2-14.7 5.2-14.7 5.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgEmpathy;